// extracted by mini-css-extract-plugin
module.exports = {"root":"EventPreviewSection_root__wo4rm"};